import { createContext, useContext, useRef } from "react";

type GuardFn = (action: () => void) => void;

const NavigationGuardContext = createContext<{
    setGuard: (fn: GuardFn | null) => void;
    requestNavigation: GuardFn;
}>({
    setGuard: () => {},
    requestNavigation: (action) => action(),
});

export function useNavigationGuard() {
    return useContext(NavigationGuardContext);
}

export function NavigationGuardProvider({ children }: { children: React.ReactNode }) {
    const guardRef = useRef<GuardFn | null>(null);

    const setGuard = (fn: GuardFn | null) => {
        guardRef.current = fn;
    };

    const requestNavigation: GuardFn = (action) => {
        if (guardRef.current) guardRef.current(action);
        else action();
    };

    return (
        <NavigationGuardContext.Provider value={{ setGuard, requestNavigation }}>
            {children}
        </NavigationGuardContext.Provider>
    );
}